import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        display: false,
        message: "",
        type: "default",
    }),
    actions: {
        send(message, type = "default") {
            this.message = message;
            this.display = true;
            this.type = type;
        },

    },
    getters: {

    },
});